import { calculateItemTotal } from "../../orderCommons/index.js";
import { getItemTypeQuantities } from "../../orderCommons/index.js";
import { groupItemsByCaseSizeRules } from "../../orderRules/index.js";
import { filterDiscountApplicableItems } from "../priceTierDiscountCommons.js";

type OrderItem = {
  price: number;
  discountable: boolean;
  quantity: number;
  containerType: string | null;
  packQuantity: number | null;
  volume: number | null;
  unit: string | null;
};

type PriceTierDiscountType = "percentage" | "perpetual-flat";

type PriceTierDiscountItemType =
  | "keg"
  | "can"
  | "cask"
  | "bottle"
  | "draught"
  | "bagInBox";

type VolumeDiscount = {
  id: number;
  deletedAt: Date | null;
  type: PriceTierDiscountType;
  amount: number;
  quantity: number;
  itemType: PriceTierDiscountItemType | null;
  minimumBasketValue: number;
  VolumeDiscountsId: number | null;
};

type CaseSizeRule = {
  quantity: number;
  containerType: "can" | "bottle";
  volume: number;
  unit: string;
};

export const filterApplicableVolumeDiscounts = ({
  orderItemList,
  caseSizeRuleList,
  volumeDiscountList,
}: {
  orderItemList: OrderItem[];
  caseSizeRuleList: CaseSizeRule[];
  volumeDiscountList: VolumeDiscount[];
}) => {
  const discountableOrderItemList = orderItemList.filter(
    (item) => item.discountable,
  );

  const discountableOrderItemListGroupedByCaseSizeRule =
    groupItemsByCaseSizeRules({
      orderItemList: discountableOrderItemList,
      caseSizeRuleList,
    }).map((item) => {
      // round down non integer item quantities down otherwise partial quantities can be aggregated
      return { ...item, quantity: Math.floor(item.quantity) };
    });

  const itemQuantitiesByContainerType = getItemTypeQuantities({
    orderItemList: discountableOrderItemListGroupedByCaseSizeRule,
  });

  return volumeDiscountList.filter((discount) => {
    // 'minimum basket volume' type discount

    if (discount.minimumBasketValue > 0) {
      // discountableOrderItemList used as case size rule grouped order items lose pricing
      const applicableOrderItems = filterDiscountApplicableItems({
        orderItems: discountableOrderItemList,
        discountItemType: discount.itemType,
      });

      const applicableOrderItemAmountSpent =
        calculateItemTotal(applicableOrderItems);

      return applicableOrderItemAmountSpent >= discount.minimumBasketValue;
    }

    // 'minimum order quantity' type discount

    const discountItemType = discount.itemType ?? "any"; // itemType is 'null' is containerTypeAny

    const orderItemQuantityOfDiscountContainerType =
      itemQuantitiesByContainerType[discountItemType];

    return orderItemQuantityOfDiscountContainerType >= discount.quantity;
  });
};
